import { render, staticRenderFns } from "./WhatsAppPlatformIcon.vue?vue&type=template&id=3a664591&scoped=true"
import script from "./WhatsAppPlatformIcon.vue?vue&type=script&lang=js"
export * from "./WhatsAppPlatformIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a664591",
  null
  
)

export default component.exports